import { Effect } from "../../Materials/effect";
var name = 'mrtFragmentDeclaration';
var shader = "#if __VERSION__>=200\nlayout(location=0) out vec4 glFragData[{X}];\n#endif\n";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var mrtFragmentDeclaration = { name: name, shader: shader };
//# sourceMappingURL=mrtFragmentDeclaration.js.map